import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components/macro';
import ActionsCard from '../engine/ActionsCardEngine';
import { SwitchControl } from '../form/Switch';
import Animation from '../Animation';

const ToggleWrapper = styled(Grid)`
  && {
    flex-direction: column;
    display: flex;
  }
`;

const ToggledActionsCardView = ({
  isActive,
  disabled,
  disableToggle,
  hideToggle,
  onToggleChange,
  onWrapperClick,
  actionButtons,
  children,
  onDelete,
  onDisabledClicked,
  id,
  isDeleteSequenceStart,
  onDeleteSequenceStart,
  deleteDialogProps,
  ...actionsCardProps
}) => {
  return (
    <Animation type="collapse" in={!isDeleteSequenceStart}>
      <Grid container>
        <Grid item xs={hideToggle ? 12 : 11}>
          <ActionsCard
            {...{
              id,
              actionButtons,
              onDelete,
              isActive,
              disabled,
              onDisabledClicked,
              onDeleteSequenceStart,
              deleteDialogProps,
              ...actionsCardProps
            }}
            isInAnimatedConrainer
          >
            {children}
          </ActionsCard>
        </Grid>

        {!hideToggle && (
        <ToggleWrapper item xs={1} onClick={onWrapperClick}>
          {/* // toggle on/off */}
          <SwitchControl
            centred
            checked={isActive}
            disabled={disableToggle}
            onChange={onToggleChange}            
            data-testid={'switch-' + id}
          />
        </ToggleWrapper>
        )}
      </Grid>
    </Animation>
  );
};

export default ToggledActionsCardView;
